import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

const HomePageBanner = () => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  return (
    <div className="bg-gradient-to-r from-blue-500 to-[#21E8E6] py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-white">
            Build a better career
          </h1>
          <h1 className="text-2xl font-bold text-white max-w-xl m-auto pt-10">
            Get instant solutions in real-time with live one-to-one on all your
            problems, topic-wise
          </h1>
          <div className="my-10 flex items-center justify-center flex-row space-x-2">
            <p className="text-base text-white">
              Not satisfied? Get your money back instantly
              <span
                className="relative"
                onMouseEnter={() => setTooltipVisible(true)}
                onMouseLeave={() => setTooltipVisible(false)}
              >
                <FaInfoCircle className="text-white ml-2 inline-block" />
                {isTooltipVisible && (
                  <span className="tooltip absolute top-0 left-0 transform -translate-x-full bg-black text-white text-base py-5 px-5 rounded opacity-90 w-80 h-48">
                    If you are not satisfied with the experience in a session,
                    tell us the exact reason in the feedback. Once we verify
                    your feedback, we will transfer your money promptly to your
                    source account
                  </span>
                )}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageBanner;
